import { render, staticRenderFns } from "./card-step.vue?vue&type=template&id=9b4d4a6a&scoped=true&"
import script from "./card-step.vue?vue&type=script&lang=js&"
export * from "./card-step.vue?vue&type=script&lang=js&"
import style0 from "./card-step.vue?vue&type=style&index=0&id=9b4d4a6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4d4a6a",
  null
  
)

export default component.exports